"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.space = space;
function space(l1, l2) {
    const { latitude: lat1 = 0, longitude: lng1 = 0 } = l1;
    const { latitude: lat2 = 0, longitude: lng2 = 0 } = l2;
    const radLat1 = (lat1 * Math.PI) / 180.0;
    const radLat2 = (lat2 * Math.PI) / 180.0;
    const a = radLat1 - radLat2;
    const b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
    let s = 2 *
        Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * 6378.137;
    s = Math.round(s * 10) / 10;
    return s;
}
//# sourceMappingURL=geographic.js.map